import React from 'react';
import styled from 'styled-components';
import { mixins, media } from 'theme';
import Icon from 'components/Icon';

const Container = styled.div`
	background-color: #ff0d00;
	color: #fff;
`;

const Center = styled.div`
	margin: 0 auto;
	padding-top: 14px;
	padding-bottom: 14px;
	display: flex;
	align-items: center;
	justify-content: center;
	${mixins.center}
`;

const IconWrapper = styled.div`
	fill: #fff;
	line-height: 0;
	margin-right: 8px;
	flex-shrink: 0;

	svg {
		width: 34px;
		height: 34px;
	}

	${media.tablet`
		svg {
			width: 26px;
			height: 26px;
		}
	`}
`;

const Text = styled.p`
	font-weight: 700;
	font-size: 16px;
	letter-spacing: 0.5px;
	margin: 0;
	text-align: center;
	max-width: 230px;

	${media.tablet`
		max-width: none;
	`}
`;

function InfoBar() {
	return (
		<Container>
			<Center>
				<IconWrapper>
					<Icon name="info" size={24} />
				</IconWrapper>
				<Text>TARJETAS SUSPENDIDAS MOMENTÁNEAMENTE</Text>
			</Center>
		</Container>
	);
}

export default InfoBar;